export default "__VITE_ASSET__Ce4EUFSM__"